<template>
    <div>
        <notifications></notifications>
        <v-app>
            <v-main class="d-flex justify-center align-center bg-img">
                <router-view></router-view>
            </v-main>
        </v-app>
    </div>
</template>
<script>
export default {
    props: {
        backgroundColor: {
            type: String,
            default: 'black'
        }
    },
    inject: {
        autoClose: {
            default: true
        }
    },
    data() {
        return {
            responsive: false,
            showMenu: false,
            menuTransitionDuration: 250,
            pageTransitionDuration: 300,
            year: new Date().getFullYear()
        }
    },

    methods: {
        linkClick() {
            if (
                this.autoClose &&
                this.$sidebar &&
                this.$sidebar.showSidebar === true
            ) {
                this.$sidebar.displaySidebar(false)
            }
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
        },
        toggleNavbar() {
            document.body.classList.toggle('nav-open')
            this.showMenu = !this.showMenu
        },
        closeMenu() {
            document.body.classList.remove('nav-open')
            this.showMenu = false
        },
        onResponsiveInverted() {
            if (window.innerWidth < 991) {
                this.responsive = true
            } else {
                this.responsive = false
            }
        }
    },
    mounted() {
        this.onResponsiveInverted()
        window.addEventListener('resize', this.onResponsiveInverted)
    },
    beforeDestroy() {
        this.closeMenu()
        window.removeEventListener('resize', this.onResponsiveInverted)
    },
    beforeRouteUpdate(to, from, next) {
        // Close the mobile menu first then transition to next page
        if (this.showMenu) {
            this.closeMenu()
            setTimeout(() => {
                next()
            }, this.menuTransitionDuration)
        } else {
            next()
        }
    }
}
</script>
<style>
.bg-img {
    background-image: url('/img/pg_login.png');
}
</style>
